import RequestHandler from "./RequestHandler";

function LanguagesAPI() {
    const baseLanguagesAPI = "languages";

    async function getLanguages() {
        try {
            const result = await RequestHandler.get(baseLanguagesAPI);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getLanguages,
    };
}

export default LanguagesAPI();
